import { render, staticRenderFns } from "./RouterRole.vue?vue&type=template&id=d3a7e742&"
import script from "./RouterRole.vue?vue&type=script&lang=js&"
export * from "./RouterRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports